<div class="nc-splitter" [ngClass]="'nc-splitter-' + ncLayout" style="--ncGutterSize: {{ncGutterSize + 'px'}};
    --ncGutterColor: {{ncGutterColor}};
    --ncGutterHoverColor: {{ncGutterHoverColor}};
    --ncGutterIconColor: {{ncGutterIconColor}};
    --ncGutterHitSize: {{ncGutterHitSize + 'px'}};">
    <ng-container *ngFor="let panel of panels; let i = index; let last = last">
        <div class="panel" [style.flexBasis.%]="panel.ncPanelSize">
            <ng-container *ngTemplateOutlet="panel.contentTemplate"></ng-container>
        </div>
        <div *ngIf="!last" class="nc-splitter-gutter" [ngClass]="'nc-splitter-gutter-' + ncLayout"
            (mousedown)="onMouseDown($event, i)" (touchstart)="onTouchStart($event, i)"></div>
    </ng-container>
</div>